import React, { useState, useEffect } from 'react';
import './Loader.css';
import desktopVideo from '../assets/lcp-loader-desktop.mp4';
import mobileVideo from '../assets/lcp-loader-mobile.mp4';

const Loader = ({ onLoadComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const LOADER_DURATION_MS = 5000;

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768); // Using 768px as the breakpoint based on App.css
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        onLoadComplete();
      }, 800);
    }, LOADER_DURATION_MS);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', checkIsMobile);
    };
  }, [onLoadComplete]);

  const handleVideoError = () => {
    setFadeOut(true);
    setTimeout(() => {
      onLoadComplete();
    }, 800);
  };

  return (
    <div className={`loader-container ${fadeOut ? 'fade-out' : ''}`}>
      <video
        className="loader-video"
        src={isMobile ? mobileVideo : desktopVideo}
        autoPlay
        muted
        playsInline
        preload="auto"
        onError={handleVideoError}
      />
    </div>
  );
};

export default Loader;
